import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from '../modal-base-component';
import {CARDGROUPINFO, RESPONSEITEM} from '../../../../gen/swagger-api';
import {AlertService} from '../../../shared/services/alert.service';
import {Observable} from 'rxjs';
import {ErrorHandlingService} from '../../../shared/services/error-handling-service';
import {DefaultService} from "../../../../gen/swagger-api/api/default.service";

const bigInt = require('big-integer');

@Component({
  selector: 'app-sc-delete-cards-modal',
  templateUrl: './sc-delete-cards-modal.component.html',
  styleUrls: ['./sc-delete-cards-modal.component.css']
})
export class ScDeleteCardsModalComponent extends ModalBaseComponent implements OnInit {

  private defaultService: DefaultService;
  public title: string;
  public subtitle: string;
  public selection = -1; // 0 - Selection from Content browser, 1 - Define range, 2 - upload via file
  public operation = '';
  public cards: Array<string>;
  public step = 'step1';
  public cardGroups: Array<CARDGROUPINFO> = [];
  public sourceCard: CARDGROUPINFO;
  public rangeVeis: string;
  public rangeQuantity: number;
  public menu: string; // CARD - for card Groups.  SUBSCIPTION - for subscrition pools;
  public idName = 'Veis';
  public importIds: string;
  @Output() action = new EventEmitter();
  private fileText: String;
  public errorResponse: Array<RESPONSEITEM>;
  public showeisConsistOnlyNumbersError = false;
  public showCardGroupSelectedError = false;
  public showUploadFileError = false;
  public showQuantityError = false;
  public showSelectRadioButtonError = false;
  public uploaded = false;
  private alertService: AlertService;

  constructor(private inject: Injector, private _bsModalRef: BsModalRef, defaultService: DefaultService,
              alertService: AlertService,
              private errorHandlingService: ErrorHandlingService) {
    super(inject);
    this.defaultService = defaultService;
    this.alertService = alertService;
  }

  ngOnInit(): void {

  }

  public setSelection(value: number) {
    this.selection = value;
    if (value === 0) {
      this.subtitle = '';
    } else if (value === 1) {
      this.subtitle = '';
    } else if (value === 2) {
      this.subtitle = '';
    }
    this.showSelectRadioButtonError = false;
  }

  // call this whenever you want to close modal
  public closeModal(): void {
    this._bsModalRef.hide();
  }

  public delete(): void {
    this.cards.forEach(item => {
      this.defaultService.cardsEidOrIccidDelete(item).subscribe();
    });
    this.action.emit(true);
    this._bsModalRef.hide();
  }

  public next() {
    if (this.selection === -1) {
      this.showSelectRadioButtonError = true;
      return;
    }

    this.step = 'step2';
    this.showCardGroupSelectedError = false;
    this.showeisConsistOnlyNumbersError = false;
    this.showUploadFileError = false;
    this.showQuantityError = false;
    this.showSelectRadioButtonError = false;
    if (this.selection === 0) {
      this.subtitle = 'Are you sure you want to delete the selected cards?';
    }
  }


  saveCards() {

    if (this.selection === 0) {
      this.showeisConsistOnlyNumbersError = false;
      this.deleteOperation(this.cards);

    } else if (this.selection === 1) {

      if (!this.rangeVeis || !this.validateeis(this.rangeVeis.toString())) {
        this.showeisConsistOnlyNumbersError = true;
        return;
      } else {
        this.showeisConsistOnlyNumbersError = false;
      }
      if (this.rangeQuantity === undefined) {
        this.showQuantityError = true;
        return;
      }

      const rangeArr = new Array<string>();
      for (let i = 0; i <= this.rangeQuantity; i++) {
        const splusplus = this.addition(this.rangeVeis, i);
        rangeArr.push(splusplus);
      }

      this.deleteOperation(rangeArr);


    } else if (this.selection === 2) {
      if (!this.uploaded) {
        this.showUploadFileError = true;
        return;
      }
      let rangeArr = [];
      this.fileText = this.fileText.replace(/\r/gi, '');
      this.fileText = this.fileText.replace(/\t/gi, '');
      rangeArr = this.fileText.split('\n');
      rangeArr = rangeArr.filter(item => item !== '');
      const finalArr = [];
      rangeArr.forEach(x => {
        finalArr.push(x.trim());
      });

      this.deleteOperation(finalArr);
    }

  }

  private deleteOperation(cards) {

    const calls = [];
    cards.forEach(item => {
      calls.push(this.defaultService.cardsEidOrIccidDelete(item));
    });

    Observable.forkJoin(calls).subscribe(
      item => {
        if (item.length === calls.length) {
          this.action.emit(true);
          this._bsModalRef.hide();
        } else {
          this.action.emit(false);
          this._bsModalRef.hide();
        }
      },
      error => {
        {
          console.error(error);
          this.errorHandlingService.errorHandling(error);
        }
      }
    );
  }

  public addition(baseNumber: string, plus: number) {
    return bigInt(baseNumber.trim()).add(plus).toString();
  }

  public back(): void {
    this.step = 'step1';
    this.showCardGroupSelectedError = false;
    this.showeisConsistOnlyNumbersError = false;
    this.showUploadFileError = false;
    this.showQuantityError = false;
    this.rangeQuantity = undefined;
    this.rangeVeis = undefined;
    this.subtitle = '';
  }

  fileUpload(event) {
    const reader = new FileReader();
    reader.readAsText(event.srcElement.files[0]);
    const me = this;
    reader.onload = function () {
      me.fileText = reader.result;
    };
    if (reader.onload) {
      this.uploaded = true;
      this.showUploadFileError = false;
    } else {
      this.uploaded = false;
      this.showUploadFileError = true;
    }
  }

  close() {
    this.action.emit(true);
    this._bsModalRef.hide();
  }

  validateeis(eis: string) {
    return /^\d+$/.test(eis);
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/sc-delete-cards-modal/sc-delete-cards-modal.component.ts